/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import $ from 'jquery';

const AIVoice = () => {
  let location = useLocation();
  return (
    (location.pathname === "/company/voicefilter" ?
    <>
      <div className="fixed-link" style={{ "position": "fixed", "bottom": "280px", "right": "20px" }}>
        <a className="fixed-ai" href="" target={"_blank"} rel="noreferrer">
          <img src={require("../../image/aiVoice-btn.png").default} style={{ "height": "140px" }} alt="aiVoice-btn" />
        </a>
      </div>
    </>
       : <></>
    )
  )
}

function FloatButton() {
  let location = useLocation();
  const [url, setUrl] = useState("");
  // toTop按鈕
  const handleScroll = event => {
    var sticky = $("header"), gotop = $(".btn_top")
    if (event.srcElement.scrollTop >= 45) {
      sticky.addClass("sticky");
    } else { sticky.removeClass("sticky"); }

    if (event.srcElement.scrollTop >= 200) {
      gotop.addClass("sticky");
    } else { gotop.removeClass("sticky"); }
  };
  // toTop按鈕(使用build後可刪除)
  $(window).scroll(function () {
    var sticky = $("header"),
      gotop = $(".btn_top")
    if ($(window).scrollTop() >= 45) {
      sticky.addClass("sticky");
    } else { sticky.removeClass("sticky"); }
    if ($(window).scrollTop() >= 200) {
      gotop.addClass("sticky");
    } else { gotop.removeClass("sticky"); }
  });

  useEffect(() => {
    if (location.pathname === "/container/mod")
      setUrl("/container/mod2")
    else
      setUrl("https://www.hamimall.com.tw/order.php?id=300734")

    window.addEventListener('scroll', handleScroll, true);
  }, [location])

  return (
    <>
      <div className="fixed_button">
        <a href={url} className="btn_buy" target="_blank" rel="noreferrer"><span>立即購買</span></a>
        <a href="#" className="btn_top">TOP</a>
      </div>

      {/* AI濾鏡 */}
      {/* <AIVoice /> */}
    </>
  )
}

export default FloatButton;